import http from '@/communication/AuthConnection'

export default async (form) => {
  const { supplierId } = form

  try {
    await http.patch(`/v1/suppliers/supplier/${supplierId}`, form)
    return true
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/brain/record/suppliers/update-supplier/index.js